<li [className]="message.client ? 'cliente' : (message.system ? 'system' : 'servidor')">
      <div class="message">
     
      <p [innerHTML]="message.content | linkify"> 
      
      </p>
  	  <div class="timeform">
     	 <i class="fa fa-clock-o" aria-hidden="true"></i> 
     	 <!-- TODO: hay que exponer info. de la entrega del mensaje (si se entrega o hay error)
     	 <span [className]="message.client ? 'delivered' : 'hidden' ">Entregado  &#10003;</span>
     	 -->
     	 <span class="timestamp">{{message.timestamp | date : 'dd/MM/yyyy H:mm' }}</span>
     	 
   	 </div>
	 
    </div>
    
  </li>
  